import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  AddformResponse,
  FormCommonResponse,
  FormDataPayload,
  FormDetailsResponse,
  FormHeaderPayload,
  FormHeaderResponse,
  FormItem,
  FormResponse,
  TicksheetDataResponse,
  TicksheetListResponse,
  TicksheetSubmitPayload,
  UpdateRowPayload,
  UpdateTicksheetDetailsPayload,
  UpdateTicksheetDetailsResponse,
} from '@core/interface/ticksheet';
import { environment } from '@environment/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TicksheetService {
  constructor(private http: HttpClient) {}

  getforms(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<FormResponse>(
      environment.endPoints.ticksheetFormList,
      {
        params: httpParams,
      }
    );
  }
  addform(data: FormDataPayload) {
    return this.http.post<AddformResponse>(
      environment.endPoints.ticksheetFormAdd,
      data
    );
  }
  deleteform(id: number) {
    return this.http.get<FormCommonResponse>(
      environment.endPoints.ticksheetFormDelete(id),
      { observe: 'response' }
    );
  }

  createFormHeader(data: FormHeaderPayload) {
    return this.http.post<FormHeaderResponse>(
      environment.endPoints.ticksheetHeaderCreate,
      data
    );
  }

  getFormDetails(form_id: number) {
    let httpParams = new HttpParams({ fromObject: { form_id } });
    return this.http.get<FormDetailsResponse>(
      environment.endPoints.ticksheetGetFormData,
      {
        params: httpParams,
      }
    );
  }

  getTicksheets(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<TicksheetListResponse>(
      environment.endPoints.ticksheetList,
      {
        params: httpParams,
      }
    );
  }

  getCheckedTicksheets(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<TicksheetListResponse>(
      environment.endPoints.checkedTicksheetList,
      {
        params: httpParams,
      }
    );
  }

  getTicksheetData(tick_sheet_id: number) {
    let httpParams = new HttpParams({ fromObject: { tick_sheet_id } });

    return this.http.get<TicksheetDataResponse>(
      environment.endPoints.getTicksheetData,
      {
        params: httpParams,
      }
    );
  }

  updateTimesheetRow(data: UpdateRowPayload) {
    return this.http.post<FormCommonResponse>(
      environment.endPoints.updateRowTicksheet,
      data
    );
  }

  updateTimesheetDetails(data: UpdateTicksheetDetailsPayload) {
    return this.http.post<UpdateTicksheetDetailsResponse>(
      environment.endPoints.updateTicksheetDetail,
      data
    );
  }

  checkTicksheetByTeam(ids: number[], remark: string) {
    const formData = new FormData();
    formData.append('ids', ids.join(','));
    formData.append('remark', remark);
    return this.http.post<FormCommonResponse>(
      environment.endPoints.checkTicksheetByTeam,
      formData
    );
  }
}
